import { useEffect, useRef } from "react"
import Quill from "quill"
import "quill/dist/quill.snow.css"

const QuillEditor = ({
  value,
  onChange,
  onBlur,
  placeholder,
  height = 200,
  invalid = false, // Add invalid prop
  ...props
}) => {
  const editorRef = useRef(null)
  const quillInstance = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (editorRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: "snow",
        placeholder: placeholder,
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
          ],
        },
      })

      // Set initial value
      if (value) {
        quillInstance.current.clipboard.dangerouslyPasteHTML(value)
      }

      // Handle text change
      quillInstance.current.on("text-change", () => {
        const content = quillInstance.current.root.innerHTML
        if (onChange) {
          onChange(content)
        }
      })

      // Handle blur event
      quillInstance.current.on("selection-change", range => {
        if (!range && onBlur) {
          onBlur()
        }
      })
    }

    return () => {
      if (quillInstance.current) {
        quillInstance.current = null
      }
    }
  }, [])

  // Update content when value prop changes
  useEffect(() => {
    if (quillInstance.current && value !== undefined) {
      const currentHtml = quillInstance.current.root.innerHTML
      // Only update if the value actually differs from what Quill currently shows
      if (value !== currentHtml && value !== currentHtml.replace(/<p><br><\/p>/g, "")) {
        quillInstance.current.clipboard.dangerouslyPasteHTML(value || "")
      }
    }
  }, [value])

  // Apply error styling when invalid
  useEffect(() => {
    if (containerRef.current) {
      const editorElement = containerRef.current.querySelector('.ql-container');
      if (editorElement) {
        if (invalid) {
          editorElement.style.borderColor = '#d9534f';
        } else {
          editorElement.style.borderColor = '#ccc';
        }
      }
    }
  }, [invalid]);

  return (
    <div ref={containerRef}>
      <div
        style={{
          height: typeof height === "string" ? `${height}` : `${height}px`,
          marginBottom: "0.5rem",
        }}
        ref={editorRef}
        className={invalid ? 'quill-editor-error' : ''}
      />
    </div>
  )
}

export default QuillEditor